
import { Component, Mixins, Watch } from "vue-property-decorator";
import ViewPrepaidsDetailCard from "@/components/Contracts/Prepaids/ViewPrepaidsDetailCard.vue";
import BaseCardListDetail from "@/components/Base/CardListDetail/BaseCardListDetail.vue";
import Prepaid from "@/interfaces/Contracts/Prepaid";
import CardListDetailMixin from "@/mixins/CardListDetailMixin";

@Component({
  components: {
    BaseCardListDetail,
    ViewPrepaidsDetailCard,
  },
})
export default class ViewPrepaidsCardListDetail extends Mixins(
  CardListDetailMixin
) {
  setSelectedItem(item: Prepaid | null): void {
    if (item === null) return;
    this.selectedItem = (this.cachedData as Prepaid[]).find(
      (prepaid) => prepaid.prepaidId === item.prepaidId
    );
  }

  updateCachedDataItem(oldItem: Prepaid, newItem: Prepaid) {
    this.cachedData = (this.cachedData as Prepaid[]).filter(
      (prepaid) => prepaid.prepaidId !== prepaid.prepaidId
    );
    this.cachedData.push(newItem);
  }

  @Watch("selectedItem")
  selectedItemChanged(newValue: Prepaid, oldValue: Prepaid) {
    if (
      oldValue !== null &&
      newValue !== null &&
      oldValue.prepaidId === newValue.prepaidId
    ) {
      //item was updated with new info as user browses, update cached data
      this.updateCachedDataItem(oldValue, newValue);
    }
  }
}
